import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UpdateBankAccountPayload } from '../models/auth.models';
import { ApiConfigService } from './api-config.service';

@Injectable({
  providedIn: 'root',
})
export class BankAccountService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiConfig: ApiConfigService,
  ) {}

  /** PUT /api-design{suffixe}/bank-accounts/update */
  updateBankAccount(payload: UpdateBankAccountPayload): Observable<unknown> {
    const url = this.apiConfig.buildUrl('DESIGN', 'BANK_ACCOUNT', 'UPDATE');
    return this.http.put<unknown>(url, payload);
  }
}
